import { FieldsConfigResponse } from "@hooks/use-config-context/types";
import { buildSubFieldsConfig } from "./format-utils";

export const formatAssetForSave = (
  toSave: Record<string, any>,
  config: FieldsConfigResponse,
) => {
  const subFieldsConfig = buildSubFieldsConfig(config);

  let meta_box = {} as Record<string, any>;

  Object.entries(toSave).forEach(([key, value]) => {
    if (key === "id" || key === "asset_id" || key === "title") {
      return; // Skip asset ID fields
    }

    const fieldConfig = (config[key] || subFieldsConfig[key]) as any;

    // Convert single values to arrays for relationship fields
    let processedValue = value;
    if (key === "asset_to_user_to") {
      processedValue = Array.isArray(value) ? value : value ? [value] : [];
    }

    if (!fieldConfig) {
      return;
    }

    if (!fieldConfig.parentFieldId) {
      meta_box[key] = processedValue;
      return;
    }

    const parentKey = fieldConfig.parentFieldId;
    const parentConfig = config[parentKey] as any;

    /*
     * Clone: true / Repeatable Fields must remain arrays.
     * If subfield value is present, append it as a new entry in the parent array.
     */
    if (
      parentConfig?.clone === true &&
      parentConfig.id !== "asset_to_user_to" && // Exclude relationship field from this logic
      parentConfig.id !== "ticket_to_asset_from" // Exclude relationship field from this logic
    ) {
      const existingArray = Array.isArray(meta_box[parentKey])
        ? meta_box[parentKey]
        : Array.isArray(toSave[parentKey])
          ? toSave[parentKey]
          : [];

      if (
        processedValue !== undefined &&
        processedValue !== null &&
        processedValue !== ""
      ) {
        meta_box[parentKey] = [...existingArray, { [key]: processedValue }];
      } else {
        meta_box[parentKey] = existingArray;
      }

      return;
    }

    //* clone: false / non-repeating fields stay as nested objects
    meta_box[parentKey] = {
      ...(meta_box[parentKey] || {}),
      [key]: processedValue,
    };
  });

  const toSaveData = {
    meta_box,
  } as Record<string, any>;

  if (toSave.title) {
    toSaveData.title = toSave.title;
  }

  return toSaveData;
};
